module.exports = __webpack_public_path__ + "static/media/corporate-services-img85.84b71353.jpg";